import { Typography, Box } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Order } from '../../../../app/services/api/orderManagementClient';

interface OrdersHeadlineProps {
  orders: Order[];
}

const OrdersHeadline = ({ orders }: OrdersHeadlineProps) => {
  // Calculate current and previous month order counts
  const now = new Date();
  const thisMonth = now.getMonth();
  const thisYear = now.getFullYear();
  const lastMonth = thisMonth === 0 ? 11 : thisMonth - 1;
  const lastMonthYear = thisMonth === 0 ? thisYear - 1 : thisYear;

  let currentMonthOrders = 0;
  let previousMonthOrders = 0;
  const totalOrders = orders.length;

  orders.forEach(order => {
    const deliveryDate = new Date(order.deliveryDate);
    if (deliveryDate.getFullYear() === thisYear && deliveryDate.getMonth() === thisMonth) {
      currentMonthOrders++;
    } else if (deliveryDate.getFullYear() === lastMonthYear && deliveryDate.getMonth() === lastMonth) {
      previousMonthOrders++;
    }
  });

  const currentPercent = totalOrders === 0 ? 0 : (currentMonthOrders / totalOrders) * 100;
  const previousPercent = totalOrders === 0 ? 0 : (previousMonthOrders / totalOrders) * 100;
  const percentChange = currentPercent - previousPercent;
  const isPositive = percentChange >= 0;

  return (
    <Box
      sx={{
        minWidth: '150px', textAlign: 'center', padding: '16px',
      }}>
      <Typography
        color="text.secondary"
        gutterBottom>
        Orders
      </Typography>
      <Typography
        component="h3"
        sx={{ fontWeight: 900, color: 'primary.main', my: 1 }}
      >
        {currentMonthOrders}
      </Typography>
      <Box display="flex"
        alignItems="center"
        justifyContent="center"
        mt={1}>
        {isPositive ? (
          <ArrowUpwardIcon color="success"
            fontSize="small" />
        ) : (
          <ArrowDownwardIcon color="error"
            fontSize="small" />
        )}
        <Typography
          component="div"
          color={isPositive ? 'success.main' : 'error.main'}
          sx={{ ml: 0.5 }}
        >
          {isPositive ? '+' : ''}{percentChange.toFixed(1)}%
        </Typography>
      </Box>

      <Typography
        component="div"
        color="text.secondary"
        sx={{ ml: 0.5 }}>
        vs last month
      </Typography>
    </Box>
  );
};

export default OrdersHeadline;
